import { BusinessSeatsType } from '@api';
import { z } from 'zod';

const businessSeatsFormSchema = z.object({
  maxSeats: z.number().nullable(),
  uplift: z.number().nullable(),
  share: z.number().nullable(),
  notes: z.string(),
});

type BusinessSeatsFormSchemaType = typeof businessSeatsFormSchema;
export type BusinessSeatsFormDataType = z.infer<BusinessSeatsFormSchemaType>;

type UseVenueBusinessSeatsFormSchemaReturnType = {
  schema: BusinessSeatsFormSchemaType;
  defaultValues: BusinessSeatsFormDataType;
};

export const useVenueBusinessSeatsFormSchema = (
  venueBusinessSeats: BusinessSeatsType
): UseVenueBusinessSeatsFormSchemaReturnType => {
  const defaultValues: BusinessSeatsFormDataType = {
    maxSeats: venueBusinessSeats.maxSeats,
    uplift: venueBusinessSeats.uplift ? venueBusinessSeats.uplift.value : null,
    share: venueBusinessSeats.share ? venueBusinessSeats.share.value : null,
    notes: venueBusinessSeats.notes ?? '',
  };

  return { schema: businessSeatsFormSchema, defaultValues };
};
